import { DatepickerTranslationNames } from '../../../../shared/modules/configurable-form/components/form-input-date/models/datepicker-translation-names';

export const defaultDateTranslationNames = {
  placeholder: 'comp.datepicker.placeholder',
  cancel: 'comp.datepicker.button.cancel',
  apply: 'comp.datepicker.button.apply',
  months: 'global.monthNames',
  monthsShort: 'global.ShortDayMonths',
  daysShort: 'global.ShortDayNames',
  daysLong: 'global.ShortDayNames',
  daysMin: 'global.ShortDayNames',
  momentFormat: 'global.formatDate',
} as DatepickerTranslationNames;
